import { render, staticRenderFns } from "./search-box-dropdown.vue?vue&type=template&id=b049d0c6&"
import script from "./search-box-dropdown.vue?vue&type=script&lang=js&"
export * from "./search-box-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./search-box-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports